export default {"src":"/login-app/[GIT_HASH]/_next/static/media/dot_filled.f5f32375.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};